exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-feed .container {\n  overflow: hidden; }\n  app-feed .container:hover {\n    overflow: auto; }\n\napp-feed .media-body .description {\n  padding-bottom: 2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/common-module/feed/feed.component.scss
// module id = ../../../../../src/app/common-module/feed/feed.component.scss
// module chunks = main